/****************************************************************/
/*                                                              */
/*                This is an Auto-Generated File                */
/*                           Made By                            */
/*             Namirasoft SDK Generator NPM Package             */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*          Please do not make any change to this file          */
/*    If any change is required, ns-sdkg command must be used   */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*                 Namira Software Corporation                  */
/*                    https://namirasoft.com                    */
/*                                                              */
/****************************************************************/

import { NSABaseServer } from "./NSABaseServer";
import { NamirasoftAccountServerAccess } from "./NamirasoftAccountServerAccess";
import { NamirasoftAccountServerCountry } from "./NamirasoftAccountServerCountry";
import { NamirasoftAccountServerEmail } from "./NamirasoftAccountServerEmail";
import { NamirasoftAccountServerHealthz } from "./NamirasoftAccountServerHealthz";
import { NamirasoftAccountServerNotificationSetting } from "./NamirasoftAccountServerNotificationSetting";
import { NamirasoftAccountServerPassword } from "./NamirasoftAccountServerPassword";
import { NamirasoftAccountServerPhone } from "./NamirasoftAccountServerPhone";
import { NamirasoftAccountServerServiceSession } from "./NamirasoftAccountServerServiceSession";
import { NamirasoftAccountServerServiceUser } from "./NamirasoftAccountServerServiceUser";
import { NamirasoftAccountServerSession } from "./NamirasoftAccountServerSession";
import { NamirasoftAccountServerSessionCategory } from "./NamirasoftAccountServerSessionCategory";
import { NamirasoftAccountServerSessionField } from "./NamirasoftAccountServerSessionField";
import { NamirasoftAccountServerSessionTag } from "./NamirasoftAccountServerSessionTag";
import { NamirasoftAccountServerUser } from "./NamirasoftAccountServerUser";
import { NamirasoftAccountServerUserCategory } from "./NamirasoftAccountServerUserCategory";
import { NamirasoftAccountServerUserField } from "./NamirasoftAccountServerUserField";
import { NamirasoftAccountServerUserTag } from "./NamirasoftAccountServerUserTag";
import { NamirasoftAccountServerValue } from "./NamirasoftAccountServerValue";
import { TokenManager } from "./TokenManager";

export class NamirasoftAccountServer extends NSABaseServer
{
    healthz: NamirasoftAccountServerHealthz;
    value: NamirasoftAccountServerValue;
    country: NamirasoftAccountServerCountry;
    email: NamirasoftAccountServerEmail;
    password: NamirasoftAccountServerPassword;
    phone: NamirasoftAccountServerPhone;
    session_category: NamirasoftAccountServerSessionCategory;
    session_field: NamirasoftAccountServerSessionField;
    session_tag: NamirasoftAccountServerSessionTag;
    session: NamirasoftAccountServerSession;
    access: NamirasoftAccountServerAccess;
    user_category: NamirasoftAccountServerUserCategory;
    user_field: NamirasoftAccountServerUserField;
    user_tag: NamirasoftAccountServerUserTag;
    user: NamirasoftAccountServerUser;
    service_user: NamirasoftAccountServerServiceUser;
    service_session: NamirasoftAccountServerServiceSession;
    notification_setting: NamirasoftAccountServerNotificationSetting;
    constructor(base_url: string, manager: TokenManager, onError: (error: Error) => void)
    {
        super(base_url, `1.4.72`, manager, onError);
        this.healthz = new NamirasoftAccountServerHealthz(this);
        this.value = new NamirasoftAccountServerValue(this);
        this.country = new NamirasoftAccountServerCountry(this);
        this.email = new NamirasoftAccountServerEmail(this);
        this.password = new NamirasoftAccountServerPassword(this);
        this.phone = new NamirasoftAccountServerPhone(this);
        this.session_category = new NamirasoftAccountServerSessionCategory(this);
        this.session_field = new NamirasoftAccountServerSessionField(this);
        this.session_tag = new NamirasoftAccountServerSessionTag(this);
        this.session = new NamirasoftAccountServerSession(this);
        this.access = new NamirasoftAccountServerAccess(this);
        this.user_category = new NamirasoftAccountServerUserCategory(this);
        this.user_field = new NamirasoftAccountServerUserField(this);
        this.user_tag = new NamirasoftAccountServerUserTag(this);
        this.user = new NamirasoftAccountServerUser(this);
        this.service_user = new NamirasoftAccountServerServiceUser(this);
        this.service_session = new NamirasoftAccountServerServiceSession(this);
        this.notification_setting = new NamirasoftAccountServerNotificationSetting(this);
    }
};